import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import userImageUrl from "../../../../assets/images/user.png";
import botImageUrl from "../../../../assets/images/mg-face-crop.jpeg";
import key_takeaways_url from "../../../../assets/audios/key_takeaways.mp3";
import piece_of_advice_url from "../../../../assets/audios/piece_of_advice.mp3";
import stakeholder_url from "../../../../assets/audios/stakeholder.mp3";
import Parser from "html-react-parser";
import sanitizeHtml from "sanitize-html";
import { IconButton, Snackbar, Dialog, DialogContent, DialogTitle, Button, DialogActions, CircularProgress } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import PauseOutlinedIcon from "@mui/icons-material/PauseOutlined";
import YouTubeIcon from '@mui/icons-material/YouTube';
import {
    ThumbDownAltOutlined,
    ThumbUpAltOutlined,
    VolumeUpOutlined,
    VolumeOffOutlined,
} from "@mui/icons-material";
import { AudioVisualizer } from "react-audio-visualize";
import ReplyIcon from '@mui/icons-material/Reply';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import VolumeUp from '@mui/icons-material/VolumeUp';
import { ShareTextOnTwitter, ShareIcons } from "./socialShare";
import { EmailIcon, FacebookIcon, LinkedinIcon, WhatsappIcon } from "react-share";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import LikeIconSvg from "../../../../assets/svgicons/Like.svg";
import DislikeIconSvg from "../../../../assets/svgicons/Dislike.svg";
import CheckmarkIconSvg from "../../../../assets/svgicons/Checkmark.svg";
import Typewriter from "typewriter-effect";
import copy from "copy-to-clipboard";
import { useSelector } from "react-redux";
import { RootState } from "../../../../globals/redux/store/store.index";
import { fetchEventSource } from "@microsoft/fetch-event-source";
import ReactMarkdown from "react-markdown";
import toWav from "audiobuffer-to-wav";
import axios from "axios";
import * as ChatActions from "../../chat.actions";
import CustomWaveForm from "../CustomWaveForm";
import { ChatService } from "../../../../services/chatService";
import AvatarComponent from "./videoAvatar.index";
import CustomAudioPlayer from "../CustomAudioPlayer";
declare global {
    interface Window {
        webkitAudioContext: typeof AudioContext;
    }
}
interface Props {
    messageId: string;
    text: string;
    imgUrl:string;
    sender: string;
    audioUrlKey: string;
    displayAudioControl: boolean;
    onFeedbackButtonClicked: (
        messageId: string,
        action: "TU" | "TD",
        feedbackText: string | null,
        checkboxResponses: string[],
    ) => void;
    messageFeedbackApiStatus: "inprogress" | "complete" | "failed" | null;
    onThumbsDownButtonClicked: (messageId: string) => void;
    feedbackAction?: "TU" | "TD" | null;
    onTextContainerResized: () => void;
    forHistory?: string;
}
const AudioUrls = {
    "key_takeaways_url": key_takeaways_url,
    "piece_of_advice_url": piece_of_advice_url,
    "stakeholder_url": stakeholder_url,
}

const AudioMessage: React.FC<Props> = ({
    messageId,
    text,
    imgUrl,
    sender,
    audioUrlKey = null,
    displayAudioControl = false,
    onFeedbackButtonClicked,
    messageFeedbackApiStatus,
    onThumbsDownButtonClicked,
    feedbackAction = null,
    onTextContainerResized,
    forHistory,
}) => {
    let className = "sent message";
    let imageUrl = userImageUrl;
    const eventSourceRef = useRef(null);
    const audioElementRef = useRef(null);
    const fullAudioRef = useRef(new Uint8Array());
    const fullAudioRefTest = useRef(new Uint8Array());
    const chunkQueueRef = useRef([]); // Queue to store incoming audio chunks

    const isPlayingRef = useRef(false);
    const isStreamingRef = useRef(true); // Ref to track if streaming is still ongoing
    const visualizerRef = useRef<HTMLCanvasElement>(null);
    const [blob, setBlob] = useState<Blob>();
    const [apicalled, setApicalled] = useState(false);
    const [BotAnswered, setBotAnswered] = useState(false);
    const audioContextRef = useRef(null);

    const [isPlaying, setIsPlaying] = useState(true); // State to track playback status
    const [isMuted, setIsMuted] = useState(false);
    const [showAudioElement, setshowAudioElement] = useState(false);
    const [typingEnds, setTypingEnds] = useState(true);
    const textRef = useRef<HTMLDivElement>();
    let apiCalled = false;
    const supportsMediaSource = typeof window !== "undefined" && typeof window.MediaSource !== "undefined";
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const dispatch = useDispatch();
    const chatState = useSelector<RootState, { [key: string]: any }>(
        (state) => state.chatV2Reducer,
    );
    if (sender === "assistant") {
        className = "received message";
        imageUrl = botImageUrl;
    }
    const canAccessQnA = localStorage.getItem("canAccessQnA");
    const setMessageTypeAudio = (
    ) => {
        if (!apiCalled && !audioUrlKey) {
            apiCalled = true
            ChatService.setMessageType(
                messageId,
            );
        }
    };

    useEffect(() => {
        if (
            messageId &&
            chatState.audioMessageId &&
            chatState.lastReceivedMessage &&
            chatState.lastReceivedMessage?.message_id == messageId
        ) {
            const message_id = chatState.audioMessageId;
            console.log('going for source')
            if (supportsMediaSource && !isIOS) {
                audio_script_non_ios()
            } else {
                // setshowAudioElement(false)
                audio_script_ios()
            }



            dispatch(ChatActions.setAudioMessageId(null));
            // handleButtonClick(message_id);
        }
        // eslint-disable-next-line
    }, [messageId]);
    useEffect(() => {
        if (
            chatState.isBotAnswering == "success"
        ) {
            setBotAnswered(true)
        }
    }, [chatState.isBotAnswering]);

    const [audioUrl, setAudioUrl] = useState('');

    let total_duration = 2
    function calculateAudioDuration(audioChunks) {
        const totalSize = audioChunks.reduce((acc, chunk) => acc + chunk.length, 0);
        const bitrate = 128000; // Replace with actual bitrate value
        if ((totalSize / (bitrate / 8)) > total_duration) {
            total_duration = totalSize / (bitrate / 8); // Duration in seconds
        }
        console.log('total duration after new chunk: ', total_duration)
    }

    function audio_script_non_ios() {
        const audioElement = document.getElementById(`audioElement_${messageId}`) as HTMLAudioElement;
        // setPlayingAudio(true);
        let allAudioChunks = []
        // const audioSource = document.getElementById(`audioSource_${messageId}`) as HTMLMediaElement;
        const mediaSource = new MediaSource();
        mediaSource.addEventListener('error', function (event) {
            console.error("MediaSource error:", event);
        }, false);


        if (!audioUrlKey) {
            mediaSource.addEventListener('sourceopen', function (event) {
                var sourceBuffer = mediaSource.addSourceBuffer('audio/mpeg');
                var eventSource = new EventSource(`${process.env.REACT_APP_API_BASE_URL}audioevents/` + chatState.audioMessageId);
                eventSource.onopen = function (event) {
                    console.log('EventSource connection opened.');
                };
                eventSource.onmessage = function (event) {
                    var eventData = JSON.parse(event.data);
                    console.log('onmessage', eventData);
                    if (!showAudioElement) {
                        setshowAudioElement(true)
                    }
                    if (eventData.sequence === 'START') {
                        // setPlayingAudio(true);
                        if (chatState.isMicClicked && audioElement && audioElement.paused) {
                            audioElement.play();
                        }
                    }
                    if (eventData.sequence === 'streaming') {
                        if (chatState.isMicClicked && audioElement && audioElement.paused) {
                            audioElement.play();
                        }
                        appendAudioData(eventData.text);
                    } else if (eventData.sequence === 'FINAL_AUDIO_END') {
                        console.log('Received final audio end message. Closing EventSource connection.');
                        setTimeout(() => {eventSource.close();},5000);
                        dispatch(
                            ChatActions.isMicClicked(0),
                        );
                        streamEnded = true;
                        endStreamIfDone();
                    }
                };
                eventSource.onerror = function (error) {
                    console.error('EventSource failed:', error);
                    eventSource.close();
                };
                eventSource['onclose'] = function (event) {
                    if (event.wasClean) {
                        console.log('EventSource connection closed cleanly, code:', event.code, 'reason:', event.reason);
                    } else {
                        console.error('EventSource connection abruptly closed.');
                    }
                };

                var appendQueue = [];
                var isAppending = false;
                var streamEnded = false;

                // Marking the stream as ended gives the audio a finite duration, which is needed for seeking
                function endStreamIfDone() {
                    if (streamEnded && appendQueue.length === 0 && !sourceBuffer.updating && mediaSource.readyState === 'open') {
                        mediaSource.endOfStream();
                    }
                }

                function processAppendQueue() {
                    if (appendQueue.length > 0 && !isAppending) {
                        isAppending = true;
                        var data = appendQueue.shift();
                        sourceBuffer.appendBuffer(data);
                    }
                }

                function appendToQueue(audioArray) {
                    appendQueue.push(audioArray);
                    processAppendQueue();
                }

                function appendAudioData(base64String) {
                    var audioBinary = window.atob(base64String);
                    var audioArray = new Uint8Array(audioBinary.length);
                    for (var i = 0; i < audioBinary.length; i++) {
                        audioArray[i] = audioBinary.charCodeAt(i);
                    }

                    try {
                        appendToQueue(audioArray);
                        allAudioChunks.push(audioArray);
                        calculateAudioDuration(allAudioChunks)
                    } catch (err) {
                        console.error('Error appending audio data:', err);
                    }
                }

                sourceBuffer.addEventListener('updateend', function () {
                    isAppending = false;
                    processAppendQueue();
                    endStreamIfDone();
                });
            });
        } else {
            audioElement.src = AudioUrls[audioUrlKey];
        }


        audioElement.onerror = function (error) {
            console.error('Error playing audio:', error);
        };
        if (!audioUrlKey) {
            audioElement.src = URL.createObjectURL(mediaSource);
        }
    }

    function audio_script_ios() {
        const audioElement = document.getElementById(`audioElement_${messageId}`) as HTMLAudioElement;
        const audioChunks: Uint8Array[] = [];
        const mimeType = "audio/mpeg";
        let allAudioChunks = [];

        if (!audioUrlKey) {
            const eventSource = new EventSource(`${process.env.REACT_APP_API_BASE_URL}audioevents/` + chatState.audioMessageId);

            eventSource.onopen = function () {
                console.log('EventSource connection opened (iOS).');
            };

            eventSource.onmessage = function (event) {
                const data = JSON.parse(event.data);

                if (data.sequence === "streaming") {
                    const base64 = data.text;

                    if (typeof base64 !== "string") {
                        console.warn("Skipping chunk: audio_base64 is missing or not a string", base64);
                        return;
                    }

                    try {
                        const cleanedBase64 = base64.startsWith("data:") ? base64.split(",")[1] : base64;
                        const byteCharacters = window.atob(cleanedBase64);
                        const byteArray = new Uint8Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteArray[i] = byteCharacters.charCodeAt(i);
                        }

                        audioChunks.push(byteArray);
                        allAudioChunks.push(byteArray);
                        calculateAudioDuration(allAudioChunks);
                    } catch (err) {
                        console.error("❌ Failed to decode audio_base64 (iOS):", err, base64);
                    }
                }

                if (data.sequence === "FINAL_AUDIO_END") {
                    try {
                        if (!showAudioElement) {
                            setshowAudioElement(true)
                        }
                        const blob = new Blob(audioChunks, { type: mimeType });
                        const audioURL = URL.createObjectURL(blob);
                        audioElement.src = audioURL;
                    } catch (err) {
                        console.error("❌ Failed to play audio blob (iOS):", err);
                    }

                    eventSource.close();
                }
            };

            eventSource.onerror = function (error) {
                console.error('EventSource failed (iOS):', error);
                eventSource.close();
            };

        } else {
            // Fallback for predefined audio file
            audioElement.src = AudioUrls[audioUrlKey];
        }

        audioElement.onerror = function (error) {
            console.error('Error playing audio (iOS):', error);
        };
    }


    useEffect(() => {
        let resizeObserver = new ResizeObserver(() => {
            onTextContainerResized();
        });
        resizeObserver.observe(textRef.current);
        // eslint-disable-next-line
    }, []);

    const [isHoveredTU, setIsHoveredTU] = useState(false);
    const [isHoveredTD, setIsHoveredTD] = useState(false);
    const [isHoveredCopy, setIsHoveredCopy] = useState(false);
    const [isHoveredShare, setIsHoveredShare] = useState(false);
    const [isCopied, setIsCopied] = useState(false);

    const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);

    const handleSnackbarClose = () => {
        setIsSnackbarOpen(false);
    };

    const copyToClipboard = () => {
        copy(text);
        setIsSnackbarOpen(true);
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 3500);
    };

    const findTargetText = (messageId) => {
        let previousMessage = { message_id: 1, message: "test" };

        const messageIndex = chatState.messages.findIndex(msg => msg.message_id === messageId);

        if (messageIndex !== -1) {
            if (messageIndex > 0) {
                previousMessage = {
                    message_id: chatState.messages[messageIndex - 1].message_id,
                    message: chatState.messages[messageIndex - 1].message
                };
            }
        }

        return previousMessage;
    };

    const textToShare = text;
    const combinedText = `${findTargetText(messageId).message}\n\n${textToShare}`;
    const twitterText = `Check out QnA with Marshall's AI Avatar. Great insights there. Give it a try at`;
    const QnAText = `Question: ${findTargetText(messageId).message}\n\nAnswer: ${textToShare}`;

    const [redirectMessage, setRedirectMessage] = useState("")
    const [isOpen, setIsOpen] = useState(false);

    const openDialog = () => {
        setIsOpen(true);
    };

    const closeDialog = () => {
        setIsOpen(false);
    };

    const handleEmailClick = () => {
        const subject = encodeURIComponent("Check out my QnA with Marshall's AI Avatar");
        const body = encodeURIComponent(`Below is the conversation I had with Dr. Marshall. I found it quite insightful. Check it out. You too may want to give it a try!\n\n\ Question: ${findTargetText(messageId).message}\n\n Answer: ${textToShare.substring(0, 1150)}\n\n Give it a try at ${"https://marshallgoldsmith.ai/"}`);

        const mailtoLink = `mailto:?subject=${subject}&body=${body}`;
        window.open(mailtoLink, '_blank');
    };

    const handleWhatsAppClick = () => {
        const body = encodeURIComponent(`Check out my QnA with Marshall's AI Avatar\n\nGreat insights!\n\nQuestion: ${findTargetText(messageId).message}\n\nAnswer: ${textToShare}\n\nGive it a try at ${"https://marshallgoldsmith.ai/"}`);

        const Link = ` https://wa.me/?text=${body}`;
        window.open(Link, '_blank');
    };

    const [snackbarOpenShare, setSnackbarOpenShare] = useState(false);
    const [secondsLeft, setSecondsLeft] = useState(5);

    useEffect(() => {
        let countdown;
        if (snackbarOpenShare) {
            countdown = setInterval(() => {
                setSecondsLeft((prevSeconds) => prevSeconds - 1);
            }, 1000);
        } else {
            setSecondsLeft(5);
        }

        return () => clearInterval(countdown);
    }, [snackbarOpenShare]);

    const handleLinkedInClick = () => {
        copy(QnAText);
        setSnackbarOpenShare(true);
        setRedirectMessage("LinkedIn");
        setTimeout(() => {
            setSnackbarOpenShare(false);
            const ShareLink = "https://www.linkedin.com/sharing/share-offsite/?url=https://marshallgoldsmith.ai";
            window.open(ShareLink, '__blank');
        }, 5000);
    };

    const handleFacebookClick = () => {
        copy(QnAText);
        setSnackbarOpenShare(true);
        setRedirectMessage("Meta");
        setTimeout(() => {
            setSnackbarOpenShare(false);
            const FbShareLink = "https://www.facebook.com/sharer/sharer.php?u=https://marshallgoldsmith.ai";
            window.open(FbShareLink, '__blank');
        }, 5000);
    };

    const handleShareSnackbarClose = () => {
        setSnackbarOpenShare(false);
    };

    const typingSpeed = 1; // Adjust typing speed as needed
    const [displayText, setDisplayText] = useState('');
    const [displayImage, setDisplayImage] = useState('');
    const currentIndexRef = useRef(0);
    let timeoutId;

    useEffect(() => {
        const typeText = () => {
            if (currentIndexRef.current < text.length) {
                setTypingEnds(false)
                const newText = text.slice(0, currentIndexRef.current + 1);
                setDisplayText(newText);
                currentIndexRef.current++;
                // typeText();
                timeoutId = setTimeout(typeText, typingSpeed);
            } else {
                setTypingEnds(true)
            }
        };

        typeText();

        return () => {
            clearTimeout(timeoutId);
        };
    }, [text, typingSpeed]);

    useEffect(() => {
        let typingStopped = false;

        const checkTypingStopped = () => {
            if (!typingStopped && displayText === text) {
                typingStopped = true;
                console.log("Typing stopped");
                dispatch(ChatActions.setStreamStarted(0));
            }
        };

        checkTypingStopped();

        return () => {
            checkTypingStopped();
        };
    }, [displayText, text]);
    const audioRef = useRef(null);

    const avatarStartHandler = () => {
        dispatch(ChatActions.setvideoMode('On'));
    }

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentImageUrl, setCurrentImageUrl] = useState('');

    const handleImageClick = (url) => {
        setCurrentImageUrl(url);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    return (
        <div className={className}>
            <div className={sender === "user" ? "top-user" : "top"}>
                {sender === "user" && (
                    <>
                        <div className="user-text" ref={textRef}>
                            {Parser(sanitizeHtml(text))}
                        </div>
                        <div className="image">
                            <img
                                src={imageUrl}
                                alt="ub"
                                className="image-user"
                            />
                        </div>
                    </>
                )}
                {sender === "assistant" && (
                    <>
                        <div className="image">
                            <img src={imageUrl} alt="ub" className="image" />
                        </div>

                        {/* <AvatarComponent closeModalHandler={handleClose} messageId={messageId} userInp={displayText} /> */}

                        <div className="answer-section">
                        <div className="answer-block">
                            <div className="text-t" ref={textRef}>
                                {canAccessQnA === "yes" ? chatState.lastReceivedMessage?.message_id == messageId ? 
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20px' }}>
                                    {chatState.imageUrl && <img
                                        src={chatState.imageUrl}
                                        alt="Chat Thumbnail"
                                        onClick={() => handleImageClick(chatState.imageUrl)}
                                        style={{ cursor: 'pointer', width:'50%', margin:'10px' }} // Thumbnail styling
                                    />}
                                </div>: 
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20px' }}>
                                    {imgUrl && <img
                                        src={imgUrl}
                                        alt="Additional Thumbnail"
                                        onClick={() => handleImageClick(imgUrl)}
                                        style={{ cursor: 'pointer', width:'50%', margin:'10px' }} // Thumbnail styling
                                    />}
                                </div>:<></>}
                                {sender === "assistant" ? (
                                    <ReactMarkdown>
                                        {chatState.lastReceivedMessage?.message_id == messageId && chatState.setStreamStarted == 1
                                            ? displayText
                                            : text}
                                    </ReactMarkdown>
                                ) : (
                                    Parser(sanitizeHtml(text))
                                )}
                                

                            </div>
                            <Dialog
                                open={isModalOpen}
                                onClose={handleCloseModal}
                                maxWidth="lg"
                                fullWidth
                                aria-labelledby="image-dialog-title"
                            >
                                <div style={{ position: 'relative' }}>
                                    <img src={currentImageUrl} alt="Full Size Modal" style={{ width: '100%' }} />
                                    <IconButton
                                        onClick={handleCloseModal}
                                        aria-label="close"
                                        style={{
                                            position: 'absolute',
                                            top: 0,
                                            right: 0,
                                        }}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                </div>
                                <DialogActions>
                                    {/* If you do not need extra actions, you might even remove DialogActions */}
                                </DialogActions>
                            </Dialog>
                        </div>

                        <div
                            className={
                                sender === "assistant" && typingEnds === true
                                    ? "actions actions-panel"
                                    : "hiddenAudioBar actions actions-panel"
                            }
                        >
                                {sender === "assistant" && (
                                    <>
                                        <div>
                                            {showAudioElement && (
                                                <CustomAudioPlayer audioRef={audioElementRef} messageId={messageId} />
                                            )}
                                            <audio className={`audio-player `} onPlay={setMessageTypeAudio} ref={audioElementRef} id={`audioElement_${messageId}`}
                                                style={{ display: 'none' }}
                                            >
                                                <source id={`audioSource_${messageId}`} type="audio/mpeg" />
                                                Your browser does not support the audio element.
                                            </audio>
                                        </div>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            {/* {BotAnswered && (
                                            <IconButton
                                                className="button"
                                                title="Avatar Video"
                                                disabled={
                                                    messageFeedbackApiStatus ===
                                                    "inprogress"
                                                }
                                                onClick={() => {
                                                    avatarStartHandler()
                                                }}
                                                style={{
                                                    color: isHoveredTU
                                                                ? "#696969"
                                                                : "red",
                                                    transition: "color 0.3s",
                                                }}
                                            >
                                                <YouTubeIcon />
                                            </IconButton>
                                        )} */}
                                            <IconButton
                                                className="button"
                                                title="Good Answer"
                                                disabled={
                                                    messageFeedbackApiStatus ===
                                                    "inprogress"
                                                }
                                                onClick={() => {
                                                    onFeedbackButtonClicked(
                                                        messageId,
                                                        "TU",
                                                        null,
                                                        [],
                                                    );
                                                }}
                                                onMouseEnter={() =>
                                                    setIsHoveredTU(true)
                                                }
                                                onMouseLeave={() =>
                                                    setIsHoveredTU(false)
                                                }
                                            >
                                                {feedbackAction === "TU" ? (
                                                    <img src={LikeIconSvg} alt="like" style={{ width: "24px", height: "24px", backgroundColor: "rgba(35, 107, 72, 0.2)", padding: "4px", borderRadius: "8px", boxSizing: "content-box" }} />
                                                ) : (
                                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M12.6667 15.3332V21.3332M12.6667 15.3332H10.6667C10.4899 15.3332 10.3203 15.4035 10.1953 15.5285C10.0702 15.6535 10 15.8231 10 15.9999V20.6666C10 20.8434 10.0702 21.0129 10.1953 21.138C10.3203 21.263 10.4899 21.3332 10.6667 21.3332H12.6667M12.6667 15.3332L15.6667 9.99989C15.823 9.74435 16.0608 9.5489 16.3418 9.44503C16.6227 9.34116 16.9305 9.33493 17.2154 9.42734C17.5004 9.51975 17.7459 9.70543 17.9124 9.95443C18.0789 10.2034 18.1568 10.5013 18.1333 10.7999L17.3333 13.9999H20.6667C20.8599 13.9977 21.0514 14.0376 21.2277 14.1167C21.4041 14.1958 21.5611 14.3124 21.6879 14.4582C21.8147 14.6041 21.9083 14.7758 21.9622 14.9614C22.0161 15.147 22.029 15.3421 22 15.5332L21.2 20.1999C21.1518 20.5178 20.9903 20.8076 20.7453 21.0159C20.5003 21.2242 20.1882 21.3369 19.8667 21.3332H12.6667" stroke="#6A6357" stroke-width="1.06667" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                )}
                                            </IconButton>
                                            <IconButton
                                                className="button"
                                                title="Incorrect Answer"
                                                disabled={
                                                    messageFeedbackApiStatus ===
                                                    "inprogress"
                                                }
                                                onClick={() => {
                                                    onThumbsDownButtonClicked(
                                                        messageId,
                                                    );
                                                }}
                                                onMouseEnter={() =>
                                                    setIsHoveredTD(true)
                                                }
                                                onMouseLeave={() =>
                                                    setIsHoveredTD(false)
                                                }
                                            >
                                                {feedbackAction === "TD" ? (
                                                    <img src={DislikeIconSvg} alt="dislike" style={{ width: "24px", height: "24px", backgroundColor: "#B5762A1A", padding: "4px", borderRadius: "8px", boxSizing: "content-box" }} />
                                                ) : (
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M11.3338 8.66659V2.66659M11.3338 8.66659H13.3338C13.5106 8.66659 13.6802 8.59635 13.8052 8.47133C13.9302 8.3463 14.0005 8.17673 14.0005 7.99992V3.33326C14.0005 3.15644 13.9302 2.98688 13.8052 2.86185C13.6802 2.73683 13.5106 2.66659 13.3338 2.66659H11.3338M11.3338 8.66659L8.33378 13.9999C8.17747 14.2555 7.93967 14.4509 7.6587 14.5548C7.37773 14.6587 7.06997 14.6649 6.78503 14.5725C6.50009 14.4801 6.25457 14.2944 6.08804 14.0454C5.92152 13.7964 5.84369 13.4986 5.86712 13.1999L6.66712 9.99992H3.33378C3.14051 10.0021 2.94907 9.96225 2.77274 9.88311C2.5964 9.80397 2.43937 9.68743 2.31254 9.54158C2.18572 9.39573 2.09211 9.22404 2.03822 9.03842C1.98433 8.8528 1.97144 8.65768 2.00045 8.46659L2.80045 3.79992C2.84867 3.48198 3.01016 3.19218 3.25518 2.98392C3.5002 2.77565 3.81223 2.66295 4.13378 2.66659H11.3338" stroke="#6A6357" stroke-width="1.06667" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                )}
                                            </IconButton>
                                            <div className="divider"></div>
                                            <IconButton
                                                className="button"
                                                title="Copy Message"
                                                onClick={copyToClipboard}
                                                onMouseEnter={() =>
                                                    setIsHoveredCopy(true)
                                                }
                                                onMouseLeave={() =>
                                                    setIsHoveredCopy(false)
                                                }
                                            >
                                                {isCopied ? (
                                                    <img src={CheckmarkIconSvg} alt="copied" style={{ width: "24px", height: "24px", backgroundColor: "rgba(35, 107, 72, 0.2)", padding: "4px", borderRadius: "8px", boxSizing: "content-box" }} />
                                                ) : (
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M12 6H7.33333C6.59695 6 6 6.59695 6 7.33333V12C6 12.7364 6.59695 13.3333 7.33333 13.3333H12C12.7364 13.3333 13.3333 12.7364 13.3333 12V7.33333C13.3333 6.59695 12.7364 6 12 6Z" stroke="#6A6357" stroke-width="1.06667" stroke-linecap="round" stroke-linejoin="round"/>
                                                        <path d="M3.33301 10V3.33333C3.33301 2.97971 3.47348 2.64057 3.72353 2.39052C3.97358 2.14048 4.31272 2 4.66634 2H11.333" stroke="#6A6357" stroke-width="1.06667" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                )}
                                            </IconButton>
                                            <Snackbar
                                                open={isSnackbarOpen}
                                                autoHideDuration={3000}
                                                onClose={handleSnackbarClose}
                                                message="Copied!"
                                                anchorOrigin={{
                                                    vertical: "top",
                                                    horizontal: "center",
                                                }}
                                                sx={{
                                                    marginTop: "64px",
                                                    width: "100%",
                                                }}
                                            />
                                            <IconButton
                                                className="button"
                                                title="Share Content"
                                                onClick={openDialog}
                                                onMouseEnter={() =>
                                                    setIsHoveredShare(true)
                                                }
                                                onMouseLeave={() =>
                                                    setIsHoveredShare(false)
                                                }
                                                style={{
                                                    // color: isHoveredShare
                                                    //     ? "#696969"
                                                    //     : "silver",
                                                    // transition: "color 0.3s",
                                                }}
                                            >
                                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M20 13.3335C21.1046 13.3335 22 12.4381 22 11.3335C22 10.2289 21.1046 9.3335 20 9.3335C18.8954 9.3335 18 10.2289 18 11.3335C18 12.4381 18.8954 13.3335 20 13.3335Z" stroke="#565450" stroke-width="1.06667" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M12 18C13.1046 18 14 17.1046 14 16C14 14.8954 13.1046 14 12 14C10.8954 14 10 14.8954 10 16C10 17.1046 10.8954 18 12 18Z" stroke="#565450" stroke-width="1.06667" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M20 22.6665C21.1046 22.6665 22 21.7711 22 20.6665C22 19.5619 21.1046 18.6665 20 18.6665C18.8954 18.6665 18 19.5619 18 20.6665C18 21.7711 18.8954 22.6665 20 22.6665Z" stroke="#565450" stroke-width="1.06667" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M13.7334 17.0002L18.2667 19.6668M18.2667 12.3335L13.7334 15.0002" stroke="#565450" stroke-width="1.06667" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </IconButton>
                                            <Dialog open={isOpen} onClose={closeDialog}>
                                                <div className="share-dialog">
                                                    <DialogTitle style={{ fontSize: "20px", color: "white", display: "flex", flexDirection: "column", alignItems: "center", backgroundColor: "#00490A", padding: "10px" }}>
                                                        Share this via
                                                        <CancelOutlinedIcon style={window.innerWidth <= 480 ? { position: 'absolute', top: '3px', right: '3px', cursor: 'pointer', fontSize: "15px" } : { position: 'absolute', top: '5px', right: '5px', cursor: 'pointer', fontSize: "20px" }} onClick={closeDialog} />
                                                    </DialogTitle>
                                                    <DialogContent style={{ fontSize: "17.5px", padding: "6px", display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                        {/* <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-evenly" }}>
                                                            <IconButton onClick={handleLinkedInClick} style={{ padding: "0px", transform: "translateY(-2px)" }}>
                                                                <LinkedinIcon style={{ height: "50px", width: "50px", marginRight: "8px", marginLeft: "8px" }} />
                                                            </IconButton>
                                                            <ShareTextOnTwitter text={twitterText} />
                                                            <IconButton onClick={handleFacebookClick} style={{ padding: "0px", transform: "translateY(-2px)" }}>
                                                                <FacebookIcon style={{ height: "50px", width: "50px", marginRight: "8px", marginLeft: "8px" }} />
                                                            </IconButton>
                                                            <IconButton onClick={handleWhatsAppClick} style={{ padding: "0px", transform: "translateY(-2px)" }}>
                                                                <WhatsappIcon style={{ height: "50px", width: "50px", marginRight: "8px", marginLeft: "8px" }} />
                                                            </IconButton>
                                                            <IconButton onClick={handleEmailClick} style={{ padding: "0px", transform: "translateY(-2px)" }}>
                                                                <EmailIcon style={{ height: "50px", width: "50px", marginRight: "8px", marginLeft: "8px" }} />
                                                            </IconButton>
                                                            <Snackbar
                                                                open={snackbarOpenShare}
                                                                autoHideDuration={5000}
                                                                onClose={handleShareSnackbarClose}
                                                                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                                                                message={`Just paste the conversation on the ${redirectMessage} post and share. Redirecting in ${secondsLeft} seconds...`}
                                                            />
                                                        </div> */}
                                                        <ShareIcons
                                                            handleLinkedInClick={handleLinkedInClick}
                                                            handleFacebookClick={handleFacebookClick}
                                                            handleWhatsAppClick={handleWhatsAppClick}
                                                            handleEmailClick={handleEmailClick}
                                                            snackbarOpenShare={snackbarOpenShare}
                                                            handleShareSnackbarClose={handleShareSnackbarClose}
                                                            redirectMessage={redirectMessage}
                                                            secondsLeft={secondsLeft}
                                                            twitterText={twitterText}
                                                        />
                                                    </DialogContent>
                                                </div>
                                            </Dialog>
                                        </div>
                                    </>
                                )}
                        </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default AudioMessage;
